import { Collapse } from '@fox/atoms/src/collapse/index';
import { IconButton } from '@fox/atoms/src/icon-button/index';
import { LoadingBar } from '@fox/atoms/src/loading-bar/index';
import { MuiAlert, MuiAlertTitle } from '@fox/atoms/src/mui-alert/index';
import Slide from '@mui/material/Slide';
import { useInternalNotification } from './data-grid-notification-context';

/**
 * A notification component for the DataGrid that displays notifications
 * when a NotificationProvider is available
 */
export const DataGridNotification = () => {
	const notification = useInternalNotification();

	if (!notification) {
		return null;
	}

	const { state, setMinimized, dismiss } = notification;
	const { minimized, message, dismissed } = state;

	return (
		<Slide in={!!message && !dismissed} direction="left" mountOnEnter unmountOnExit>
			<MuiAlert
				severity={message?.severity ?? 'info'}
				onClose={message?.undismissable ? undefined : dismiss}
				elevation={3}
				sx={{
					ml: 2,
					position: 'absolute',
					transition: message?.undismissable ? 'all 0.3s ease, width 0.3s ease, top 0.3s ease, right 0.3s ease!important' : undefined,
					top: minimized ? '0rem' : '1rem',
					right: minimized ? '0rem' : '1rem',
					width: minimized ? '15rem' : '30rem',
					maxWidth: 'calc(100% - 2rem)'
				}}
			>
				<MuiAlertTitle
					sx={{
						marginRight: '2.5rem',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis'
					}}
				>
					{message?.title}
				</MuiAlertTitle>
				{message?.undismissable ? (
					<IconButton
						sx={{ position: 'absolute', top: '0.2rem', right: '0.2rem' }}
						iconName={minimized ? 'ExpandMore' : 'ExpandLess'}
						onClick={() => setMinimized(!minimized)}
					/>
				) : null}
				<Collapse timeout={300} in={!minimized}>
					{message?.content}
				</Collapse>
				{message?.progress ? (
					<LoadingBar
						color={message?.severity}
						value={typeof message.progress === 'number' ? message.progress : undefined}
						style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
						loading
					/>
				) : null}
			</MuiAlert>
		</Slide>
	);
};
